// Survei Kepnakes (PR #112) -- fungsi murni halaman admin (tab Master Kepnakes & Cakupan Kepnakes). Cermin aturan
// backend survei_kepnakes.py (server tetap pemeriksa akhir).
export const NAMA_MASTER_MAKS = 150;
export const SASARAN_MAKS = 100000;
const TAG_HTML = /<\s*[/!a-zA-Z]/;
// eslint-disable-next-line no-control-regex
const KONTROL = /[\u0000-\u001f\u007f-\u009f]/;

export const rapikanNama = (nama) => String(nama ?? "").normalize("NFC").replace(/\s+/g, " ").trim();

// Pesan galat nama master (null = sah).
export function periksaNamaMaster(nama) {
    if (KONTROL.test(String(nama ?? ""))) return "Nama tidak boleh memuat tab atau baris baru.";
    const bersih = rapikanNama(nama);
    if (!bersih) return "Nama wajib diisi.";
    if (bersih.length > NAMA_MASTER_MAKS) return `Nama maksimal ${NAMA_MASTER_MAKS} karakter.`;
    if (TAG_HTML.test(bersih)) return "Nama tidak boleh memuat tag HTML.";
    return null;
}

// Isian sasaran per institusi (teks dari kotak isian) -> {sasaran, galat}. Kosong = tanpa sasaran.
export function susunSasaran(isian) {
    const sasaran = {};
    for (const [id, teks] of Object.entries(isian)) {
        const t = String(teks ?? "").trim();
        if (!t) continue;
        const n = Number(t);
        if (!/^\d+$/.test(t) || n < 1 || n > SASARAN_MAKS) {
            return { sasaran: null, galat: `Sasaran harus bilangan bulat 1 sampai ${SASARAN_MAKS.toLocaleString("id-ID")}.` };
        }
        sasaran[id] = n;
    }
    return { sasaran, galat: null };
}


// Impor master dari tempelan Excel (PR #114): label status per baris & kalimat hasil simpan.
export const LABEL_STATUS_IMPOR_MASTER = {
    baru: "Baru",
    sudah_ada: "Sudah ada",
    duplikat_dalam_tempelan: "Duplikat dalam tempelan",
    tidak_valid: "Tidak valid",
};

export function tekstRingkasImporMaster(hasil) {
    const bagian = [`${hasil.disimpan} disimpan`, `${hasil.dilewati} dilewati (sudah ada/duplikat)`];
    if (hasil.tidak_valid) bagian.push(`${hasil.tidak_valid} tidak valid`);
    return `Selesai: ${bagian.join(", ")}.`;
}
